
import React from 'react';
import { MapPin } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';

const LocationSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <ScrollReveal>
            <div className="flex items-center justify-center mb-6">
              <div className="p-4 bg-white rounded-full shadow-lg">
                <MapPin className="h-8 w-8 text-blue-600" />
              </div>
            </div>
          </ScrollReveal>
          
          <ScrollReveal delay={150}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold mb-6">
              Baton Rouge-Based. National Reach.
            </h2>
          </ScrollReveal>
          
          <ScrollReveal delay={300}>
            <p className="text-xl text-gray-700 leading-relaxed">
              We're proudly based in Baton Rouge, Louisiana — serving amazing clients across the country. 
              Our local roots give us Southern hospitality and attention to detail, while our national experience 
              ensures we understand diverse markets and industries.
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
